module.exports = __webpack_public_path__ + "static/img/face10.12273f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face10.jpg
// module id = O6Z2
// module chunks = 0